import { ImagePlaceholder } from '@synergy/theme';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
    preview: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& > img': {
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
    placeholder: {
        width: '100%',
        height: '100%',
        fill: 'none',
    },
}));

export interface PreviewImageProps {
    url?: string;
    alt?: string;
}

export const PreviewImage = (props: PreviewImageProps) => {
    const classes = useStyles();
    const { url, alt } = props;
    // A file that has gone missing left the browser's broken-image mark behind,
    // where a picture that was never there shows the placeholder.
    const [failed, setFailed] = useState(false);

    useEffect(() => setFailed(false), [url]);

    return (
        <div className={classes.preview}>
            {url && !failed ? (
                <img src={url} alt={alt} onError={() => setFailed(true)} />
            ) : (
                <ImagePlaceholder className={classes.placeholder} />
            )}
        </div>
    );
};
